<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color page-card">
        <v-card>
          <v-card-title class="mx-3">
            {{
              $t(
                isNew
                  ? "CRUD.newInfo"
                  : savable
                  ? "CRUD.editInfo"
                  : "CRUD.viewInfo",
                [$t("SupplierDetail.ObjectName")]
              )
            }}
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    supplier = {};
                    $emit('mode', null);
                    $emit('input', null);
                  "
                  >fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("CRUD.backToList", [$t("SupplierDetail.ObjectName")]) }}
              </span>
            </v-tooltip>
          </v-card-title>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <ValidationObserver ref="observer">
              <v-container>
                <!-- 供应商编号 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.supplier_code") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('SupplierDetail.Fields.supplier_code')"
                      rules="required"
                    >
                      <!-- 编辑信息 -->
                      <v-text-field
                        single-line
                        v-model="supplier.supplier_code"
                        :hint="isNew ? '' : $t('SupplierDetail.codeHint')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'supplier_code')
                            .concat(errors)
                        "
                        :disabled="!!sync_supplier_data_from"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <!-- 查看信息 -->
                    {{ supplier.supplier_code }}
                  </v-col>
                </v-row>
                <!-- 供应商名称 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.supplier_name") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('SupplierDetail.Fields.supplier_name')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="supplier.supplier_name"
                        :hint="isNew ? '' : $t('SupplierDetail.nameHint')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'supplier_name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.supplier_name }}
                  </v-col>
                </v-row>
                <!-- 供应商类型 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.supply_type") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="isNew && settings && settings.account_supplier">
                    <v-radio-group row v-model="supplier.type">
                      <v-radio
                        :label="$t('SupplierDetail.SupplyType.common')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.SupplyType.platform')"
                        :key="2"
                        :value="2"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      supplier.type == 1
                        ? $t("SupplierDetail.SupplyType.common")
                        : supplier.type == 2
                        ? $t("SupplierDetail.SupplyType.platform")
                        : ""
                    }}
                  </v-col>
                </v-row>
                <!-- 订单转采购 -->
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.order_to_purchase_setting &&
                    !settings.order_to_purchase_disabled && supplier.type == 1 && (accountInfo && accountInfo.version && accountInfo.version.stock_type == 3)
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.order_to_purchase") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-checkbox
                      v-model="supplier.order_to_purchase"
                      :true-value="1"
                      :false-value="0"
                      :label="$t('SupplierDetail.Fields.order_to_purchase')"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.order_to_purchase ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.orderToPurchase." +
                            (supplier.order_to_purchase ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 采购后议价 -->
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.purchase_after_set_price &&
                    $permission.permissionAllow(
                      'Purchases',
                      'negotiatePriceSave'
                    )
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.purchase_after_set_price") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-checkbox
                      v-model="purchaseAfterSetPrice"
                      :true-value="1"
                      :false-value="0"
                      :label="
                        $t('SupplierDetail.Fields.purchase_after_set_price')
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="
                        supplier.purchase_after_set_price ? 'primary' : ''
                      "
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.purchase_after_set_price." +
                            (supplier.purchase_after_set_price ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 账单以门店验收值为标准 -->
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.order_to_purchase_setting &&
                    !settings.order_to_purchase_disabled &&
                    supplier.order_to_purchase
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.bill_for_shop_examine") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.bill_for_shop_examine">
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.bill_for_shop_examine ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.billForShopExamine." +
                            (supplier.bill_for_shop_examine ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 门店退货单是否生成采购退货对账单 -->
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.order_to_purchase_setting &&
                    !settings.order_to_purchase_disabled &&
                    supplier.order_to_purchase &&
                    supplier.bill_for_shop_examine == 1
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.return_order_stock_out") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.return_order_stock_out">
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.return_order_stock_out ? 'primary' : ''"
                      small
                      label
                    >
                      {{ $t("SupplierDetail.billForShopExamine." + (supplier.return_order_stock_out ? "on" : "off")) }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 验收差异是否生成采购退货对账单 -->
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.order_to_purchase_setting &&
                    !settings.order_to_purchase_disabled &&
                    supplier.order_to_purchase &&
                    supplier.bill_for_shop_examine == 1 &&
                    settings.examine_auto_return
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.examine_auto_return") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.examine_auto_return">
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.billForShopExamine.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.examine_auto_return ? 'primary' : ''"
                      small
                      label
                    >
                      {{ $t("SupplierDetail.billForShopExamine." + (supplier.examine_auto_return ? "on" : "off")) }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 启用供应商发货 -->
                <v-row align="center" v-if="supplier.type == 1">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.delivery_flg") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.delivery_flg">
                      <v-radio
                        :label="$t('SupplierDetail.deliveryFlg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.deliveryFlg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.delivery_flg ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.deliveryFlg." +
                            (supplier.delivery_flg ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row align="center" v-if="supplier.delivery_flg">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.delivery_modify_flg") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.delivery_modify_flg">
                      <v-radio
                        :label="$t('SupplierDetail.deliveryModifyFlg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.deliveryModifyFlg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.delivery_modify_flg ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.deliveryModifyFlg." +
                            (supplier.delivery_modify_flg ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 是否可修改商品 -->
                <v-row
                  align="center"
                  v-if="
                    supplier.order_to_purchase &&
                    settings &&
                    settings.material_for_supplier == 1
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.editMaterialFlg.ObjectName") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.edit_material_flg">
                      <v-radio
                        :label="$t('SupplierDetail.editMaterialFlg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.editMaterialFlg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.edit_material_flg ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.editMaterialFlg." +
                            (supplier.edit_material_flg ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <!-- 供应商是否启用云打印 -->
                <v-row
                  align="center"
                  v-if="$permission.permissionAllow('CloudPrints', 'index')"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.cloud_print_flg.ObjectName") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.cloud_print_flg">
                      <v-radio
                        :label="$t('SupplierDetail.cloud_print_flg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.cloud_print_flg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      :color="supplier.cloud_print_flg ? 'primary' : ''"
                      small
                      label
                    >
                      {{
                        $t(
                          "SupplierDetail.cloud_print_flg." +
                            (supplier.cloud_print_flg ? "on" : "off")
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>

                <!-- 分组: TODO 有供应商分组模块时再改会必填校验 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.group") + $t("Global.colon") }}
                    <!-- <Required :show="savable" :mode="mode" /> -->
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <!-- <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('SupplierDetail.Fields.group')"
                      rules="required"
                    >
                      <SearcherDistrict
                        v-model="supplier.district"
                        no-label
                        unclearable
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'city_1')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider> -->
                    <SearcherDistrict
                      v-model="supplier.district"
                      no-label
                      unclearable
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      supplier && supplier.district
                        ? supplier.district.name
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.national_tax_code") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="supplier.national_tax_code"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.national_tax_code }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.national_tax_type") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.tax_type">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.tax_type }}
                  </v-col>
                </v-row>
                <!-- 地址 -->
                <v-row>
                  <v-col
                    cols="3"
                    :class="
                      savable
                        ? 'font-weight-bold text-right mt-8'
                        : 'font-weight-bold text-right'
                    "
                  >
                    {{
                      $t("SupplierDetail.Fields.address") + $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <!-- 三级地址 -->
                    <CitiesSelectGroup
                      :masterItem="supplier"
                      @provinceSelected="supplier.province_id = $event.id"
                      @citySelected="supplier.city_id = $event.id"
                      @districtSelected="supplier.area_id = $event.id"
                    />
                    <v-text-field
                      single-line
                      v-model="supplier.address"
                      :label="$t('SupplierDetail.Fields.address')"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <!-- 三级地址 -->
                    <AddressText
                      :masterItem="supplier"
                      :detailAddress="supplier.address"
                    />
                  </v-col>
                </v-row>
                <!-- 负责人姓名 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.manager_name") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('SupplierDetail.Fields.manager_name')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="supplier.manager_name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'manager_tel')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.manager_name }}
                  </v-col>
                </v-row>
                <!-- email -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.email") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.email">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.email }}
                  </v-col>
                </v-row>
                <!-- 联系方式 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.tel") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('SupplierDetail.Fields.tel')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="supplier.manager_tel"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'manager_tel')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.manager_tel }}
                  </v-col>
                </v-row>
                <!-- 开户行 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.bank") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.bank">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.bank }}
                  </v-col>
                </v-row>
                <!-- 账户名称 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.account_name") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.account_name">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.account_name }}
                  </v-col>
                </v-row>
                <!-- 账户号 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.Fields.account_number") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.account_num">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.account_num }}
                  </v-col>
                </v-row>
                <!-- 税号 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.tax") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.tax_num">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.tax_num }}
                  </v-col>
                </v-row>
                <!-- 备注 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.memo") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.comment">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.comment }}
                  </v-col>
                </v-row>
                <!-- 品牌码 -->
                <v-row align="center" v-if="supplier.type == 2">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.account_id") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.account_id"/>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.account_id }}
                  </v-col>
                </v-row>
                <!-- 门店编码 -->
                <v-row align="center" v-if="supplier.type == 2">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SupplierDetail.Fields.shop_code") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="supplier.shop_code"/>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ supplier.shop_code }}
                  </v-col>
                </v-row>
                <!-- 供应商状态 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("SupplierDetail.status.ObjectName") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="supplier.stop_flg">
                      <v-radio
                        :label="$t('SupplierDetail.status.on')"
                        :key="0"
                        :value="0"
                      />
                      <v-radio
                        :label="$t('SupplierDetail.status.off')"
                        :key="1"
                        :value="1"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      supplier.stop_flg
                        ? $t("SupplierDetail.status.off")
                        : $t("SupplierDetail.status.on")
                    }}
                  </v-col>
                </v-row>
              </v-container>
            </ValidationObserver>
          </v-card-text>
        </v-card>
        <v-card class="mt-4">
          <v-card-title class="mx-3">
            {{ $t("SupplierDetail.supplier_id.ObjectName") }}
          </v-card-title>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <v-container>
              <!-- 登陆ID -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("SupplierDetail.supplier_id.login") + $t("Global.colon")
                  }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field single-line v-model="supplier.account_user_id">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    supplier && supplier.account_user
                      ? supplier.account_user.account_user_id
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 密码 -->
              <v-row align="center" v-show="savable">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("SupplierDetail.supplier_id.password") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <!-- 编辑 -->
                  <v-text-field single-line v-model="supplier.account_password">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <!-- <v-col cols="9" md="7" v-else>
                  {{ supplier.password }}
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-sheet>
      <v-sheet class="transparent-background-color page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    supplier = {};
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("SupplierDetail.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView && $permission.permissionAllow('Suppliers', 'edit')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !supplier.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("SupplierDetail.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="savable">
                <!-- 保存 -->
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !supplier.id"
                  @click="save()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("SupplierDetail.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="isView">
          <v-card-title>
            <v-row dense>
              <v-col
                cols="12"
                v-if="$permission.permissionAllow('SupplierMaterials', 'index')"
              >
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="!supplier.id"
                  :href="'/#/supplier/supplier-materials/' + supplier.id"
                >
                  {{ $t("PurchasesList.Fields.supplier_set") }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="!supplier.id"
                  :href="'/#/supplier/licences/' + supplier.id"
                >
                  {{ $t("PurchasesList.Fields.licences") }}
                </v-btn>
              </v-col>
              <!-- todo 应收应付历史查看待做 -->
              <v-col cols="12" v-if="false">
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="!supplier.id"
                  :href="'/#/history/' + supplier.id"
                >
                  {{ $t("PurchasesList.Fields.history") }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  v-if="settings && settings.account_supplier && supplier && supplier.type == 2 && $permission.permissionAllow('SupplierMaterials', 'syncAndAddAccountMaterials')"
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  @click="syncAndAddAccountMaterials()"
                >
                  {{ $t("SupplierMaterials.syncAndAddAccountMaterials") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card
          class="mt-4"
          v-if="
            isView &&
            supplier.type == 1 && //普通供应商才有
            $permission.checkPushPlatformEnabled(
              $permission.pushPlatforms.chanjet
            ) &&
            chanjetUrls &&
            chanjetUrls.SubAccount
          "
        >
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  color="info"
                  block
                  target="_blank"
                  :disabled="!supplier.id"
                  :href="chanjetUrls.Supplier + supplier.id"
                >
                  {{ $t("Oauth.bindChanjet")
                  }}<span v-if="supplier.chanjetToken">{{
                    $t("Oauth.binded")
                  }}</span>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn color="warning" block @click="syncChanjetMaterials()">
                  <v-icon x-small class="pe-1">fa-sync</v-icon>
                  {{ $t("SupplierDetail.actions.SyncMaterial") }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn color="warning" block @click="syncChanjetShops()">
                  <v-icon x-small class="pe-1">fa-sync</v-icon>
                  {{
                    $t("SupplierDetail.actions.SyncShop", [$consts.shopName()])
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import AddressText from "@/components/plugins/AddressText";
import Suppliers from "@/api/suppliers";
import Chanjet from "@/api/chanjet";
import SupplierMaterials from "@/api/supplier_materials";
import i18n from "@/i18n";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherDistrict,
    CitiesSelectGroup,
    AddressText,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountInfo", "loading", "sync_supplier_data_from"]),
  },

  data: () => ({
    serverErrors: [],
    supplier: {},
    chanjetUrls: [],
    purchaseAfterSetPrice: null, //采购后议价
  }),

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var supplier = JSON.parse(JSON.stringify(this.supplier));
            if (this.supplier.district && this.supplier.district.name) {
              supplier.city_1 = this.supplier.district.code;
            }
            delete supplier.district;
            delete supplier.password;
            delete supplier.account_user;
            supplier = Object.assign({}, supplier, {
              purchase_after_set_price: this.purchaseAfterSetPrice,
            });
            if (supplier.type == 2) {
              supplier.delivery_flg = 0
            }
            if (supplier.bill_for_shop_examine == 0) {
              supplier.return_order_stock_out = 0;
              supplier.examine_auto_return = 0;
            }
            //校验成功再提交
            Suppliers.save(supplier.id, supplier)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.supplier);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.supplier = {};
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    syncChanjetMaterials() {
      this.$store.dispatch("fullscreenLoading");
      Suppliers.syncChanjetMaterials(this.supplier.id)
        .then(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncChanjetShops() {
      this.$store.dispatch("fullscreenLoading");
      Suppliers.syncChanjetShops(this.supplier.id)
        .then(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncAndAddAccountMaterials() {
      this.$store.dispatch("fullscreenLoading");
      SupplierMaterials.syncAndAddAccountMaterials(this.supplier.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getSupplierFromAPI();
            this.$snackbar.success(i18n.t("SupplierMaterials.syncSuccessMgs"));
          }else {
            this.syncErrorData = response.data.data
            this.syncErrorDialog = true;
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    }
  },

  watch: {
    mode: {
      immediate: true,
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.mode == "new") {
          // 新建仓库，初始化默认值
          this.supplier = {
            type: 1,
            stop_flg: 0,
            delivery_flg: 0,
            bill_for_shop_examine: 0,
            return_order_stock_out: 0,
            examine_auto_return: 0,
            delivery_modify_flg: 0,
            edit_material_flg: 0,
            order_to_purchase: 0,
            account_id: "",
            shop_code: "",
          };
        }
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          Chanjet.getOauthUrl().then(
            function (response) {
              if (response.data.status.isOK()) {
                this.chanjetUrls = response.data.urls;
              }
            }.bind(this)
          );
          Suppliers.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.supplier = response.data.supplier;
                this.purchaseAfterSetPrice =
                  this.supplier.purchase_after_set_price;
                if (this.supplier.account_user)
                  this.supplier.account_user_id =
                    this.supplier.account_user.account_user_id;
              }
            }.bind(this)
          );
        }
        this.$scrollTop(); //返回顶部
      },
    },
    purchaseAfterSetPrice: {
      handler() {
        if (
          this.supplier.purchase_after_set_price &&
          !this.purchaseAfterSetPrice
        ) {
          // 供应商关闭采购后议价时进行校验
          Suppliers.checkPurchaseAfterSetPriceClose(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.purchaseAfterSetPrice = 0;
              } else {
                this.purchaseAfterSetPrice = 1;
              }
            }.bind(this)
          );
        }
      },
    },
    supplier:{
      deep:true,
      handler() {
        if (this.supplier.type == 2) {
          this.supplier.order_to_purchase = 0;
        }
      }
    },
  },
};
</script>